<template>
  <div>
    <Form @submitSuccess="getListNode" ref="form"/>
    <div class="groupButton">
      <AppButton customType="default" @click="addMenu">添加地区</AppButton>
    </div>
    <BasicTable
      hiddenFooter
      :tableData="tableData"
      :treeProps="{ children: 'sub', hasChildren: 'is_son' }"
      :lazyLoad="true"
      :columns="columns" 
      :node="node"
      @treeID="getNode">
      <template v-slot:is_enable="{ item }">
        <CheckBox v-model="item.is_enable" @change="enableChange(item)"></CheckBox>
      </template>
      <template v-slot:operate="{ item }">
        <AppButton type="primary" class="op" plain size="small" @click="openMenu(item)"><i class="fa fa-edit fa-lg icon" ></i>添加</AppButton>
        <AppButton type="primary" class="op" plain size="small" @click="editMenu(item)"><i class="fa fa-edit fa-lg icon" ></i>编辑</AppButton>
        <AppButton type="primary" class="op" v-if="item.is_son === 0" plain size="small delect" @click="deleteMenu(item)"><i class="fa fa-trash-o fa-lg icon"></i>删除</AppButton>
      </template>
    </BasicTable>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import { WebsiteService } from '../../service/website.service'
import Form from './formRegion';
const columns = [
  { name: '地区', key: 'name' },
  { name: '是否启用', key: 'is_enable', type: 'custom'},
  { name: '操作', key: 'operate', type: 'custom' },
];
  export default {
    name: 'region',
    components: { Form },
    data() {
      return {
        fields: [],
        tableData: [],
        columns,
        node: []
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList() {
        const data = await WebsiteService.getListByRegion();
        this.tableData = data;
      },
      async getListNode() {
        const data = await WebsiteService.getListByRegion();
        this.tableData = data;
        this.$router.go(0);
      },
      addMenu() {
        this.$refs.form.open('add',{});
      },
      openMenu(data) {
        this.$refs.form.open('add', data);
      },
      editMenu(data) {
        this.$refs.form.open('edit', data);
      },
      deleteMenu(data) {
        MessageBox.confirm('确定要删除这条资源吗？', '删除资源').then(async () => {
          await WebsiteService.delRegion(data.id)
          this.getListNode();
        })
      },
      filter() {
        this.getList();
      },
      async getNode(id) {
          const data = await WebsiteService.getNodeSon(id)
          this.node = data
      },
      enableChange(item) {
          WebsiteService.switchRegionStatus(item.id, item.is_enable ? 1 : 0);
      },
    }
  }
</script>

<style lang="scss" scoped>
.icon {
  font-size: 1vw;
}
.el-table__row{
  .op{
    visibility: hidden;
  }
}
.el-table__row:hover .op{
  visibility: visible;
}
</style>